module.exports = __webpack_public_path__ + "fe3c643bcc78e4ce5444f546c3419cf4.png";